// Clé du groupe des commandes non affectées (« À placer »)
export const UNASSIGNED_GROUP_KEY = '__unassigned__';

export const COLORS = {
  primary: '#079992',
  primaryDark: '#057772',
  warning: '#b7791f',
  danger: '#c0392b',
  muted: '#76808c',
  unassigned: '#9aa0a6',
};

// Seuil au-delà duquel la charge d'un camion est signalée en ambre
export const HIGH_LOAD_THRESHOLD = 90;

export const TABS = {
  ALL: 'ALL',
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
  ALERTS: 'ALERTS',
};

const decimalFormatter = new Intl.NumberFormat('fr-FR', {
  maximumFractionDigits: 1,
});

const integerFormatter = new Intl.NumberFormat('fr-FR', {
  maximumFractionDigits: 0,
});

/**
 * Formate un poids en kg : « 27 kg » en dessous d'une tonne, « 3,9 t » au-delà
 * @param {number} kg
 * @returns {string}
 */
export const formatWeight = (kg) => {
  const value = Number(kg) || 0;
  if (value >= 1000) {
    return `${decimalFormatter.format(value / 1000)} t`;
  }
  return `${integerFormatter.format(value)} kg`;
};

/**
 * Formate une distance en mètres en kilomètres arrondis
 * @param {number} meters
 * @returns {string}
 */
export const formatKm = (meters) =>
  `${integerFormatter.format((Number(meters) || 0) / 1000)} km`;

/**
 * Formate une durée en minutes : « 9 h 20 » ou « 45 min »
 * @param {number} minutes
 * @returns {string}
 */
export const formatDuration = (minutes) => {
  const total = Math.round(Number(minutes) || 0);
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours === 0) return `${rest} min`;
  return `${hours} h ${rest.toString().padStart(2, '0')}`;
};

/**
 * Taux de charge d'un camion en pourcentage (non borné)
 */
export const getLoadRate = (weight, capacity) =>
  capacity > 0 ? (weight / capacity) * 100 : 0;

/**
 * Couleur de la jauge de charge : ambre au-delà de 90 %, rouge en dépassement
 */
export const getGaugeColor = (rate) => {
  if (rate > 100) return COLORS.danger;
  if (rate >= HIGH_LOAD_THRESHOLD) return COLORS.warning;
  return COLORS.primary;
};

/**
 * Libellé complémentaire de la charge (charge élevée / dépassement)
 */
export const getLoadLabel = (rate) => {
  if (rate > 100) return 'dépassement';
  if (rate >= HIGH_LOAD_THRESHOLD) return 'charge élevée';
  return null;
};

/**
 * Liste des alertes d'une commande (utilisées par l'onglet « Alertes »)
 */
export const getDeliveryAlerts = (delivery, impossibleJobIds) => {
  const alerts = [];
  if (impossibleJobIds.includes(delivery.tourPlanningId)) {
    alerts.push({ key: 'capacity', label: 'capacité', color: COLORS.danger });
  }
  if (!delivery.coordinates) {
    alerts.push({
      key: 'geocoding',
      label: 'non géolocalisée',
      color: COLORS.warning,
    });
  }
  if (delivery.isOutOfTimeWindow || delivery.etaExceedsTimeWindow) {
    alerts.push({
      key: 'time-window',
      label: 'hors horaires',
      title: 'Après l’heure de fin de tournée du camion',
      color: COLORS.danger,
    });
  } else if (delivery.vehicleId && !delivery.etaTime) {
    alerts.push({ key: 'eta', label: 'sans ETA', color: COLORS.warning });
  }
  return alerts;
};
